/**
 * "Copy to Clipboard" functionality.
 */

const Clipboard = require('clipboard');

new Clipboard('.copy-to-clipboard');
